const states = [
  "primary",
  "secondary",
  "warning",
  "error",
  "info",
  "dark",
  "success",
  "facebook",
  "twitter",
  "google",
  "instagram",
  "pinterest",
  "youtube",
  "vimeo",
  "slack",
  "dribbble",
  "github",
];

export default states;
